import { render, staticRenderFns } from "./StiDoc.vue?vue&type=template&id=ccb7ce8a&"
import script from "./StiDoc.vue?vue&type=script&lang=js&"
export * from "./StiDoc.vue?vue&type=script&lang=js&"
import style0 from "./StiDoc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports